import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnChanges {
  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Output() pageChange = new EventEmitter<number>();

  visiblePages: number[] = [];

  ngOnChanges(): void {
    this.generateVisiblePages();
  }

  generateVisiblePages(): void {
    const pages: number[] = [];

    if (this.totalPages <= 1) {
      this.visiblePages = [1];
      return;
    }

    pages.push(this.currentPage);

    if (this.currentPage > 1) {
      pages.unshift(this.currentPage - 1);
    }

    if (this.currentPage < this.totalPages) {
      pages.push(this.currentPage + 1);
    }

    const uniquePages = Array.from(new Set(pages)).filter(p => p >= 1 && p <= this.totalPages);
    this.visiblePages = uniquePages.sort((a, b) => a - b);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }
}
